import React from 'react';
import { Line } from 'react-chartjs-2';

import { useRequiredChartPlugins } from '../plugins/usePlugins.ts';
import { ChartContainer } from '../styled.ts';
import type { ChartJSOrUndefined, ChartProps } from '../types.ts';

type ChartType = 'line';

const LineChart = React.forwardRef<ChartJSOrUndefined<ChartType>, ChartProps<ChartType>>(function LineChart(props, ref) {
  const { 'data-testid': testId, ...chartProps } = props;
  useRequiredChartPlugins<ChartType>(chartProps.options);

  return (
    <ChartContainer data-testid={testId} style={{ height: chartProps.height ? `${chartProps.height}px` : undefined }}>
      <Line ref={ref} {...chartProps} data-testid='line-chart' />
    </ChartContainer>
  );
});

export default LineChart;
